import './Contact.scss';

class Contact {

  constructor(node) {
    this.node = node;
  }

  init() {
    //console.log();
  }

}

JSModules['Contact'] = Contact;
export default Contact;
